export default {
    qiniuDomain: "https://qiniu.zhuoxue6.cn/",
}